import {
  LIST_COUNTRY_REQ,
  LIST_COUNTRY_SUCCESS,
  LIST_COUNTRY_FAILURE,
} from "../Constants/countryConstants";

export const COUNTRY_LIST_REDUCER = (state = {}, { type, payload }) => {
  switch (type) {
    case LIST_COUNTRY_REQ: {
      return { Country_List_Loading: true };
    }
    case LIST_COUNTRY_SUCCESS: {
      return { Country_List_Loading: false, Country_List: payload };
    }
    case LIST_COUNTRY_FAILURE: {
      return { Country_List_Loading: false, Country_List_Error: payload };
    }
    default:
      return state;
  }
};
